module.exports = __webpack_public_path__ + "static/media/up_arrow.2fae8e29.png";